import each from "lodash/each";
import map from "lodash/map";
import findLast from "lodash/findLast";
import find from "lodash/find";
import isFinite from "lodash/isFinite"
import range from "lodash/range"

import uniq from "lodash/uniq";
import sortBy from "lodash/sortBy";
import sum from "lodash/sum";
import filter from "lodash/filter";
import cloneDeep from "lodash/cloneDeep";

const returnElasticTimingInfo = (slideArray, total_duration_ms, slideIndex) => {
  var slide = slideArray[slideIndex];
  var minPole = slide.minPole;
  //console.log("minPole", minPole);

  var videoSlidesInGroup = filter(slideArray, s => {
    if (s.type != "video") {
      return false;
    }
    return s.minPole == minPole;
  });

  var totalVideoMsInGroup = sum(
    map(videoSlidesInGroup, v => {
      var transition_ms = (v.transition_time_in + v.transition_time_out) * 1000;
      return v.duration * 1000 - transition_ms;
    })
  );

  var imageSlidesInGroup = filter(slideArray, s => {
    if (s.type == "video") {
      return false;
    }
    return s.minPole == minPole;
  });

  var max_ms;
  //console.log(slide.maxPole, slideArray.length);
  if (slide.maxPole > slideArray.length) {
    max_ms = total_duration_ms;
  } else {
    max_ms = slideArray[slide.maxPole].timing;
  }
  var availableGroupSlideDuration = max_ms - slideArray[slide.minPole].timing;
  var availableGroupImageSlideDuration =
    availableGroupSlideDuration - totalVideoMsInGroup;

  return {
    numImageSlidesInGroup: imageSlidesInGroup.length,
    numVideosInGroup: videoSlidesInGroup.length,
    totalVideoMsInGroup: totalVideoMsInGroup,
    availableGroupImageSlideDuration: availableGroupImageSlideDuration,
    availableGroupSlideDuration: availableGroupSlideDuration
  };
};

export const returnRubberBandArray = (slideArray, total_duration_ms) => {
  // console.log("returnRubberBandArray!");
  // Find the locked slides.

  var locked_slides = [0, slideArray.length + 1];

  each(slideArray, (s, idx) => {
    if (!s.unpinned) {
      locked_slides.push(idx);
    }
  });

  locked_slides = sortBy(uniq(locked_slides));

  slideArray = map(slideArray, (s, idx) => {
    s.minPole = findLast(locked_slides, d => {
      return idx >= d;
    });
    s.maxPole = find(locked_slides, d => {
      return idx < d;
    });
    return s;
  });

  var nextPoleTime = slideArray[0].timing;
  var originalSlideArray = cloneDeep(slideArray);
  each(slideArray, (s, idx) => {
    if (!locked_slides.includes(idx)) {
      s.timing = nextPoleTime;
    }

    if (idx + 1 < slideArray.length) {
      // Calculate next slide's position.
      var timing_info = returnElasticTimingInfo(
        originalSlideArray,
        total_duration_ms,
        idx
      );
      //console.log("idx", idx, s.minPole, s.maxPole);
      //console.log(timing_info);
      var available_duration_ms =
        timing_info.availableGroupImageSlideDuration /
        timing_info.numImageSlidesInGroup;

      if (s.type == "video") {
        var transition_sec = s.transition_time_in + s.transition_time_out;
        console.log("transition_sec", transition_sec);
        nextPoleTime = nextPoleTime + (s.duration - transition_sec) * 1000;
        var additional_frame_buffer = 0 * (1000 / 25);
        nextPoleTime = nextPoleTime - additional_frame_buffer;
      } else {
        nextPoleTime = nextPoleTime + available_duration_ms;
      }

      //console.log("nextPoleTime", nextPoleTime);
    }

    delete s.minPole;
    delete s.maxPole;
  });

  return slideArray;
};

export const returnAllRubberBandArray = (slideArray, total_duration_ms, locked_minimum_slide_index) => {
  // Same as the rubberBand, but with only the first and last locked.
  // Basically, this is "spread all evenly and adjust for the videos" mode.

  var locked_slides = [0, slideArray.length + 1];

  if(isFinite(locked_minimum_slide_index)){
    // If locked_minimum_slide_index is provided, use that as the floor for spreading.
    // EG, if locked_minimum_slide_index = 3, locked_slides would be [0, 1, 2, 3, {length)}]
    // Essentially, this would spread all remaining slides equally.
    //console.log("locked_minimum_slide_index", locked_minimum_slide_index)
    locked_slides = range(0, locked_minimum_slide_index + 1);
    locked_slides.push(slideArray.length + 1)
    //console.log("locked_slides", locked_slides)
  }


  locked_slides = sortBy(uniq(locked_slides));

  slideArray = map(slideArray, (s, idx) => {
    s.minPole = findLast(locked_slides, d => {
      return idx >= d;
    });
    s.maxPole = find(locked_slides, d => {
      return idx < d;
    });
    return s;
  });

  var nextPoleTime = slideArray[0].timing;
  var originalSlideArray = cloneDeep(slideArray);
  each(slideArray, (s, idx) => {
    if (!locked_slides.includes(idx)) {
      s.timing = nextPoleTime;
    }

    if (idx + 1 < slideArray.length) {
      // Calculate next slide's position.
      var timing_info = returnElasticTimingInfo(
        originalSlideArray,
        total_duration_ms,
        idx
      );
      //console.log("idx", idx, s.minPole, s.maxPole);
      //console.log(timing_info);
      var available_duration_ms =
        timing_info.availableGroupImageSlideDuration /
        timing_info.numImageSlidesInGroup;

      if (s.type == "video") {
        var transition_sec = s.transition_time_in + s.transition_time_out;
        console.log("transition_sec", transition_sec);
        nextPoleTime = nextPoleTime + (s.duration - transition_sec) * 1000;
        var additional_frame_buffer = 0 * (1000 / 25);
        nextPoleTime = nextPoleTime - additional_frame_buffer;
      } else {
        nextPoleTime = nextPoleTime + available_duration_ms;
      }

      //console.log("nextPoleTime", nextPoleTime);
    }

    delete s.minPole;
    delete s.maxPole;
  });

  return slideArray;
};
